export default __webpack_public_path__ + "static/media/world-map.238c0481.jpg";